import { ready } from '../utils/readyinit';
import initCart from '../sections/cart';

ready(() => {
  initCart();
});
